import { createContext } from 'react'

const cardContext = createContext()

export default cardContext
